/**
 * What the review window's chat pane does when an item opens.
 *
 * The window opens straight onto the conversation: there is no cover to click
 * through (operator decision 2026-10-21). The pane asks once per
 * conversation, and stepping to another item on the same conversation keeps
 * it. An organization whose message content is switched off
 * (`content_allowed` false — `insights.transcripts`) is never asked for.
 */

export type ChatPaneStep = 'wait' | 'keep' | 'load' | 'content_off';

export interface ChatPaneItem {
  conversation_id: string | null;
  content_allowed: boolean;
}

export function chatPaneStep(item: ChatPaneItem | null, shownConversationId: string | null): ChatPaneStep {
  if (!item || !item.conversation_id) return 'wait';
  if (shownConversationId && shownConversationId === item.conversation_id) return 'keep';
  if (!item.content_allowed) return 'content_off';
  return 'load';
}

/** The key of one ask: the conversation, from the feedback it was opened at.
 *  The same key twice (React's development double run, the list item replaced
 *  by its fetched record) is one ask — one fetch, not two. */
export function askKey(conversationId: string | null, feedbackId: string | null): string | null {
  return conversationId ? `${conversationId}:${feedbackId ?? ''}` : null;
}
